import React from 'react';
import { OscarPromptChip } from '../../ai_agent';
import useSubscribedFlag from '../../hooks/useSubscribedFlag';
import { WORK_ORDER_LABELS_TRACK_FLAG } from '../../data/workOrderStarLabels';
import { canAddWOLabelsOrStarNotes } from '../../utils/DataAccessUtils';

interface Props {
	currentUser: any;
}

/**
 * "Add a reminder" under a work order's Ask Oscar box: Oscar walks the user through the reminder
 * (time, note). Shown with workorder-labels-track and the Pro entitlement reminders need. The flag
 * is subscribed here, not read by the (class) detail page, so a flag that lands after the page
 * renders still shows the chip.
 */
export const WorkOrderReminderPromptChip: React.FC<Props> = ({ currentUser }) => {
	const labelsTrackEnabled = useSubscribedFlag(WORK_ORDER_LABELS_TRACK_FLAG);
	if (!labelsTrackEnabled || !canAddWOLabelsOrStarNotes(currentUser)) return null;
	return <OscarPromptChip label="Add a reminder" prompt="Add a reminder for this work order" />;
};
